import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Grid, IconButton, Typography } from '@mui/material';
import { Back } from './Back';

interface Props {
    onEdit: () => void,
    title: string,
    urlToBack: string
}

export const TitleBar = ({ onEdit, title, urlToBack }: Props) => {
    return (
        <Grid container spacing={2}
            justifyContent="space-between"
            alignItems="center">
            <Grid item>
                <Grid container spacing={2}
                    justifyContent="space-between"
                    alignItems="center">
                    <Grid item>
                        <Typography variant="h4" component="h1">{title}</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton color="primary" aria-label="edit" onClick={onEdit}>
                            <BorderColorIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Back url={urlToBack} />
            </Grid>
        </Grid>
    )
}

